import fetch from '@/plugin/axios'

export function page (query) {
  return fetch({
    url: '/api/ocr/elementExtractRule/list',
    method: 'get',
    params: query
  })
}

export function addObj (obj) {
  return fetch({
    url: '/api/ocr/elementExtractRule/extractRule',
    method: 'post',
    data: obj
  })
}

export function getObj (id) {
  return fetch({
    url: '/api/ocr/elementExtractRule/' + id,
    method: 'get'
  })
}

export function delObj (id) {
  return fetch({
    url: '/api/ocr/elementExtractRule/' + id,
    method: 'delete'
  })
}

export function putObj (id, obj) {
  return fetch({
    url: '/api/ocr/elementExtractRule/' + id,
    method: 'put',
    data: obj
  })
}

export function initOptions () {
  return fetch({
    url: '/api/ocr/elementType/allOptions',
    method: 'get'
  })
}
export function getAllReg () {
  return fetch({
    url: '/api/ocr/elementExtractRule/all',
    method: 'get'
  })
}
